module.exports = __webpack_public_path__ + "img/qrdoctor.4c82e5da.jpg";